import type { BatchJobFilter } from '@/hooks/useWorkflowBatchJobs';
import type { BatchStatusGlyphKind } from './batchStatusGlyph';

// Linear-style status marks: a ring whose fill says how far the state got, in the
// tone the cards use for it, so the filter reads as the thing it selects.
export const STATUS_FILTERS = [
  {
    key: 'all',
    label: 'All statuses',
    glyph: 'any',
    tone: 'text-foreground/60'
  },
  {
    key: 'running',
    label: 'Running',
    glyph: 'running',
    tone: 'text-primary'
  },
  {
    key: 'completed',
    label: 'Completed',
    glyph: 'done',
    tone: 'text-green-600'
  },
  {
    key: 'failures',
    label: 'With failures',
    glyph: 'failed',
    tone: 'text-destructive'
  }
] as const satisfies readonly {
  key: BatchJobFilter;
  label: string;
  glyph: BatchStatusGlyphKind;
  tone: string;
}[];

// Radix hands `onValueChange` a plain string. The valid keys ARE this list, so
// the guard reads them off it instead of restating them somewhere they can drift.
export function isBatchJobFilter(value: string): value is BatchJobFilter {
  return STATUS_FILTERS.some(filter => filter.key === value);
}
